import React from "react";
import _ from "lodash";
import I18n from "../../../../../i18n/I18n";
import { DatePicker, Button, Dropdown, Icon } from "../../../../common";
import Helper from "../../../../../helper/Helper";
import WarehouseBox from "../../warehouseBox/WarehouseBox";
import WarehouseSelect from "../../warehouseSelect/WarehouseSelect";
import styles from "../VariantsList.scss";

const VariantsListRow = props => {
  const {
    variant,
    changedVariant,
    isFbn,
    onWarehouseChange,
    valAppend,
    inputChange,
    currencyCode,
    priceError,
    priceWarning,
    onSale,
    toggleSale,
    saleStartError,
    saleEndError,
    partnerSkuUniqueError,
    salePriceError,
    selectedStartDate,
    browser,
    selectedEndDate,
    minimumDate,
    countryCode,
    shipping_countries,
    sarPrice,
    toggleShowStockUpdate,
    showStockUpdate,
    isPartnerSkuUnique,
    copyValue,
    seller
  } = props;
  const warehouseList =
    changedVariant && changedVariant.stocks && !_.isEmpty(changedVariant.stocks)
      ? changedVariant.stocks.map((data, index) => {
          const match = changedVariant.initialStocks.find(
            initialStock =>
              initialStock &&
              initialStock.warehouse_code === data.warehouse_code
          );
          return (
            <WarehouseBox
              key={index}
              horizontal
              isFbn={isFbn}
              offerCode={changedVariant.offer_code}
              initialVal={match}
              data={data}
              onWarehouseChange={onWarehouseChange}
              valAppend={valAppend}
            />
          );
        })
      : "";

  return (
    <div>
      <div className={styles.formCtr}>
        <div className={styles.columnWrapper}>
          {props.variant && props.variant.offer_code ? (
            <div className={`${styles.inputWrapper} ${styles.arrow}`}>
              <p className={styles.inputTitle}>
                {I18n.getText("variants.seller-sku", {}, "Partner SKU")}
              </p>
              <div className={styles.checkboxWrapper}>
                <p className={styles.arrowWrapper}>
                  <input
                    type="text"
                    value={changedVariant.partner_sku}
                    name="partner_sku"
                    className={styles.textInput}
                    onChange={inputChange}
                    disabled
                    id="source"
                  />

                  {Number(changedVariant.is_partner_sku_unique) > 0 &&
                  !changedVariant.partner_sku_unique ? (
                    <div onClick={copyValue}>
                      <Icon name="fwd-arrow" className={styles.arrowIcon} />
                    </div>
                  ) : (
                    ""
                  )}
                </p>
              </div>
            </div>
          ) : (
            ""
          )}
          <div className={styles.inputWrapper}>
            <p className={styles.inputTitle}>
              {I18n.getText(
                "variants.seller-sku-unique",
                {},
                "Partner SKU Unique"
              )}
            </p>
            <div className={styles.checkboxWrapper}>
              <input
                type="text"
                value={changedVariant.partner_sku_unique}
                name="partner_sku_unique"
                className={`${styles.textInput} ${
                  partnerSkuUniqueError ? styles.errorInput : ""
                }`}
                onChange={inputChange}
              />
              {partnerSkuUniqueError ? (
                <div className={styles.error}>
                  {I18n.getText("variants.p-sku-unique-error")}
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
        <div className={styles.inputWrapper}>
          <p className={styles.inputTitle}>
            {I18n.getText(
              "variants.price",
              {
                currencyCode: I18n.formatCurrency({
                  currency: currencyCode
                })
              },
              "Price ({currencyCode})"
            )}
          </p>
          <p className={styles.inputSubtitle}>
            {I18n.getText("variants.vat-text", {}, "Price inclusive of 5% VAT")}
          </p>
          <div className={`${styles.checkboxWrapper} ${styles.priceWrapper}`}>
            <div>
              <div className={styles.currencyCode}>
                <div>
                  {I18n.formatCurrency({
                    currency: currencyCode
                  })}
                </div>
              </div>
              <input
                type="tel"
                value={changedVariant.price}
                disabled={seller && !seller.is_allow_price_edit}
                className={`${styles.textInput} ${
                  priceError ? styles.errorInput : ""
                }`}
                name="price"
                onBlur={priceWarning}
                onChange={inputChange}
              />
            </div>
          </div>
          {priceError ? (
            <div className={styles.error}>
              {I18n.getText("variants.price-error", {}, "Enter a valid price")}
            </div>
          ) : (
            ""
          )}
          <div className={styles.checkboxWrapper}>
            <input
              type="checkbox"
              name="toggleSale"
              checked={onSale}
              onChange={() => toggleSale()}
            />
            <label htmlFor="toggleSale" className={styles.locLabel}>
              {I18n.getText("variants.on-sale", {}, "Add Sale Price")}
            </label>
          </div>
        </div>
        {onSale ? (
          <div className={styles.inputWrapper}>
            <p className={styles.inputTitle}>
              {I18n.getText(
                "variants.sale-price",
                {
                  currencyCode: I18n.formatCurrency({
                    currency: currencyCode
                  })
                },
                "Sale Price ({currencyCode})"
              )}
            </p>
            <p className={styles.inputSubtitle}>
              {I18n.getText(
                "variants.vat-text",
                {},
                "Price inclusive of 5% VAT"
              )}
            </p>
            <div className={styles.checkboxWrapper}>
              <div
                className={`${styles.saleInputWrapper} ${
                  saleStartError || saleEndError || salePriceError
                    ? styles.errorInput
                    : ""
                }`}
              >
                <div className={styles.priceWrapper}>
                  <div className={styles.currencyCode}>
                    <div>
                      {I18n.formatCurrency({
                        currency: currencyCode
                      })}
                    </div>
                  </div>
                  <input
                    type="tel"
                    value={changedVariant.sale_price}
                    className={styles.saleInput}
                    disabled={seller && !seller.is_allow_price_edit}
                    name="sale_price"
                    onBlur={priceWarning}
                    onChange={inputChange}
                  />
                </div>
                {changedVariant.sale_price ? (
                  <div className={styles.singleDateWrapper}>
                    <div className={styles.datePicker}>
                      <div className={styles.dateLabel}>
                        {I18n.getText("variants.start-date", {}, "Start Date")}
                      </div>
                      {I18n.getComponent(
                        formattedValue => (
                          <DatePicker
                            selectedDate={selectedStartDate}
                            withPortal={!browser.greaterThan.tablet}
                            initialDate={changedVariant.sale_start}
                            placeholder={"YYYY-MM-DD"}
                          />
                        ),
                        "variants.start-date"
                      )}
                    </div>
                    <div className={styles.datePicker}>
                      <div className={styles.dateLabel}>
                        {I18n.getText("variants.end-date", {}, "End Date")}
                      </div>
                      {I18n.getComponent(
                        formattedValue => (
                          <DatePicker
                            selectedDate={selectedEndDate}
                            withPortal={!browser.greaterThan.tablet}
                            initialDate={changedVariant.sale_end}
                            placeholder={"YYYY-MM-DD"}
                            isOutsideRange={day => day.isBefore(minimumDate)}
                          />
                        ),
                        "variants.end-date"
                      )}
                    </div>
                  </div>
                ) : (
                  ""
                )}
              </div>
              {salePriceError ? (
                <div>
                  <div className={styles.error}>
                    {I18n.getText(
                      "variants.sale-price-error",
                      {},
                      "Sale Price should be less than Price"
                    )}
                  </div>
                </div>
              ) : (
                ""
              )}
              {saleStartError || saleEndError ? (
                <div>
                  <div className={styles.error}>
                    {I18n.getText("variants.sale-date-error")}
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        ) : (
          ""
        )}
        {countryCode === "AE" && Number(shipping_countries) === 3 ? (
          <div className={styles.ksaWrapper}>
            <div className={styles.saPriceWrapper}>
              {changedVariant.price ? (
                <div className={`${styles.inputWrapper}`}>
                  <div className={styles.saPrice}>
                    <p className={styles.inputTitle}>
                      {I18n.getText(
                        "variants.price",
                        {
                          currencyCode: I18n.formatCurrency({
                            currency: "SAR"
                          })
                        },
                        "Price ({currencyCode})"
                      )}
                    </p>
                  </div>
                </div>
              ) : (
                ""
              )}
              {changedVariant.sale_price ? (
                <div className={`${styles.inputWrapper}`}>
                  <div className={styles.saPrice}>
                    <p className={styles.inputTitle}>
                      {I18n.getText(
                        "variants.sale-price",
                        {
                          currencyCode: I18n.formatCurrency({
                            currency: "SAR"
                          })
                        },
                        "Sale Price ({currencyCode})"
                      )}
                    </p>
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        ) : (
          ""
        )}
        <div>
          <p className={styles.warehouseTitle}>
            {I18n.getText("variants.warehouse-info")}
          </p>
          <div className={`${styles.warehouseCtr}`}>
            {warehouseList}
            {changedVariant.available_warehouses &&
            changedVariant.available_warehouses.length ? (
              showStockUpdate ? (
                <WarehouseSelect
                  onWarehouseChange={onWarehouseChange}
                  changedVariant={changedVariant}
                  valAppend={valAppend}
                  horizontal
                  toggleShowStockUpdate={toggleShowStockUpdate}
                />
              ) : (
                <Button
                  variant="transparent"
                  className={styles.btn}
                  onClick={toggleShowStockUpdate}
                >
                  <Icon name="list" className={styles.icon} />
                  {I18n.getText("offers.add-new-stock")}
                </Button>
              )
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default VariantsListRow;



// WEBPACK FOOTER //
// ./src/components/products/offerDetails/variantsList/variantsListRow/VariantsListRow.js